// Discount code field for the cart drawer.
// Lives inside the cart <form>, so it uses a plain input + button instead of a
// nested form. Codes are applied through the Cart AJAX API; a valid code
// re-renders the drawer via the theme's `cart:refresh` hook, an invalid one is
// rolled back and reported inline.

const CN_LOADING = '!loading';

customElements.define('cart-discount', class extends HTMLElement {
    connectedCallback() {
        this.$input = this.querySelector('[data-element="input"]');
        this.$apply = this.querySelector('[data-element="apply"]');
        this.$error = this.querySelector('[data-element="error"]');

        this.$apply?.addEventListener('click', () => this._apply());
        this.$input?.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                this._apply();
            }
        });
        this.querySelectorAll('[data-remove-code]').forEach(($btn) => {
            $btn.addEventListener('click', () => this._remove($btn.dataset.removeCode));
        });
    }

    get appliedCodes() {
        return (this.dataset.codes || '').split(',').map((c) => c.trim()).filter(Boolean);
    }

    async _apply() {
        const code = this.$input.value.trim();
        if (!code) return;

        const previous = this.appliedCodes;
        if (previous.some((c) => c.toLowerCase() === code.toLowerCase())) {
            this.$input.value = '';
            return;
        }

        this._setLoading(true);
        this._setError('');

        try {
            const cart = await this._update([...previous, code]);
            const applied = (cart.discount_codes || []).find(
                (d) => d.code.toLowerCase() === code.toLowerCase()
            );

            if (applied && applied.applicable) {
                document.dispatchEvent(new Event('cart:refresh'));
            } else {
                await this._update(previous);
                this._setError(this.dataset.errorMsg);
                this._setLoading(false);
            }
        } catch (err) {
            console.error(err);
            this._setError(this.dataset.errorMsg);
            this._setLoading(false);
        }
    }

    async _remove(code) {
        this._setLoading(true);
        try {
            await this._update(this.appliedCodes.filter((c) => c !== code));
            document.dispatchEvent(new Event('cart:refresh'));
        } catch (err) {
            console.error(err);
            this._setLoading(false);
        }
    }

    async _update(codes) {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
        });
        if (!res.ok) throw new Error(`Cart update failed: ${res.status}`);
        return res.json();
    }

    _setLoading(state) {
        this.classList.toggle(CN_LOADING, state);
        if (this.$apply) this.$apply.disabled = state;
    }

    _setError(msg) {
        if (!this.$error) return;
        this.$error.textContent = msg || '';
        this.$error.hidden = !msg;
    }
});
